import { GeoPicker as GeoPickerField } from "components/shared/form";
import React from "react";

export default class GeoPicker extends GeoPickerField {
    render() {
        return (
            <>
                {this.renderField()}
                {this.renderError()}
            </>
        );
    }
}
